// Import the generated route tree
import { ApiResponseError } from "@/lib/errors/apiError";
import { routeTree } from "@/routeTree.gen";
import * as Sentry from "@sentry/react";
import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => failureCount < 3 && !(error instanceof ApiResponseError && error.status < 500),
    },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient, auth: undefined },
  defaultPreload: "intent",
  // Router stale times control when the router re-runs loaders and re-preloads routes
  // Since we're using React Query, we want to ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  defaultStaleTime: 0,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  // Returning null as the default pending component will result in a quick flickering when we use ensureQueryData in the loader,
  // even when the data is already in the cache. Setting a short pending time will prevent this.
  defaultPendingMs: 100,
  // Adjust this if we actually want to show a pending component.
  defaultPendingMinMs: 0,
  defaultPendingComponent: () => null,
  // Log all errors to Sentry, don't use the Sentry Error Boundary for this.
  defaultOnCatch: (error, errorInfo) => Sentry.captureReactException(error, errorInfo),
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
